"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitOfMeasureEnums = void 0;
var UnitOfMeasureEnums;
(function (UnitOfMeasureEnums) {
    // Count/Quantity
    UnitOfMeasureEnums["PCS"] = "pcs";
    UnitOfMeasureEnums["DOZ"] = "doz";
    UnitOfMeasureEnums["PR"] = "pr";
    UnitOfMeasureEnums["SET"] = "set";
    UnitOfMeasureEnums["PK"] = "pk";
    UnitOfMeasureEnums["BX"] = "bx";
    UnitOfMeasureEnums["BDL"] = "bdl";
    UnitOfMeasureEnums["RL"] = "rl";
    // Weight
    UnitOfMeasureEnums["KG"] = "kg";
    UnitOfMeasureEnums["G"] = "g";
    UnitOfMeasureEnums["MG"] = "mg";
    UnitOfMeasureEnums["OZ"] = "oz";
    UnitOfMeasureEnums["LB"] = "lb";
    UnitOfMeasureEnums["TON"] = "ton";
    // Length
    UnitOfMeasureEnums["MM"] = "mm";
    UnitOfMeasureEnums["CM"] = "cm";
    UnitOfMeasureEnums["M"] = "m";
    UnitOfMeasureEnums["KM"] = "km";
    UnitOfMeasureEnums["IN"] = "in";
    UnitOfMeasureEnums["FT"] = "ft";
    UnitOfMeasureEnums["YD"] = "yd";
    UnitOfMeasureEnums["MI"] = "mi";
    // Volume
    UnitOfMeasureEnums["ML"] = "ml";
    UnitOfMeasureEnums["L"] = "l";
    UnitOfMeasureEnums["CM3"] = "cm3";
    UnitOfMeasureEnums["M3"] = "m3";
    UnitOfMeasureEnums["FL_OZ"] = "fl_oz";
    UnitOfMeasureEnums["GAL"] = "gal";
    // Time
    UnitOfMeasureEnums["S"] = "s";
    UnitOfMeasureEnums["MIN"] = "min";
    UnitOfMeasureEnums["H"] = "h";
    UnitOfMeasureEnums["DAY"] = "day";
    UnitOfMeasureEnums["WEEK"] = "week";
    UnitOfMeasureEnums["MONTH"] = "month";
    UnitOfMeasureEnums["YEAR"] = "year";
    // Energy
    UnitOfMeasureEnums["J"] = "j";
    UnitOfMeasureEnums["KJ"] = "kj";
    UnitOfMeasureEnums["CAL"] = "cal";
    UnitOfMeasureEnums["KCAL"] = "kcal";
    UnitOfMeasureEnums["WH"] = "wh";
    UnitOfMeasureEnums["KWH"] = "kwh";
    // Power
    UnitOfMeasureEnums["W"] = "w";
    UnitOfMeasureEnums["KW"] = "kw";
    UnitOfMeasureEnums["HP"] = "hp";
    // Temperature
    UnitOfMeasureEnums["CELSIUS"] = "celsius";
    UnitOfMeasureEnums["FAHRENHEIT"] = "fahrenheit";
    UnitOfMeasureEnums["KELVIN"] = "kelvin";
})(UnitOfMeasureEnums || (exports.UnitOfMeasureEnums = UnitOfMeasureEnums = {}));
